module.exports = __webpack_public_path__ + "static/media/Clothes.aed056b4.jpg";